import Swiper, { Navigation, HashNavigation, EffectFade } from 'swiper'

const facesOfSlider = () => {
  const swiper = new Swiper('.faces-of', {
    modules: [Navigation, HashNavigation, EffectFade],
    effect: 'fade',
    loop: true,
    speed: 1000,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    hashNavigation: {
      replaceState: true,
      watchState: true,
    },
  });
}

facesOfSlider();